// extracted by mini-css-extract-plugin
export default {"docLinkBox":"DocLink_docLinkBox__SivTJ","docLinkTooltip":"DocLink_docLinkTooltip__Y8hUa"};